import gql from "graphql-tag";

const getOrCreateChatGroupQuery = gql`
    query GetOrCreateChatGroupMutation(
        $opponentId: String
        $marketplaceSlug: String
        $universitySlug: String
        $isDegreeTypesEnabled: Boolean = false
    ) {
        getOrCreateChatGroup(
            opponentId: $opponentId
            marketplaceSlug: $marketplaceSlug
            universitySlug: $universitySlug
        ) {
            id
            lastMessage {
                text
                created
            }
            unreadMessageCount
            members {
                id
            }
            opponent {
                id
                firstName
                inboxInfoOne
                inboxInfoTwo
                profilePhoto
                accountRole
                degreeLevel
                isOnline
                degrees @include(if: $isDegreeTypesEnabled) {
                    degreeType
                    degree {
                        id
                        name
                    }
                }
            }
        }
    }
`;

export default getOrCreateChatGroupQuery;
